"use client";

import { Badge } from "@/components/ui/badge";
import { siteConfig } from "@/lib/siteConfig";
import { CheckCircleIcon } from "lucide-react";

export default function CoreCapabilities() {
  return (
    <section className="wrapper py-10 square-gradient-bg">
      <div className={"flex flex-col gap-5 items-center text-center"}>
        <Badge>Core Capabilities</Badge>
        <h1 className={"text-4xl font-bold"}>
          What Makes Us <span className={"text-primary"}>Different</span>
        </h1>
        <p className={"text-muted-foreground text-lg font-semibold w-[70%]"}>
          Our unique combination of global reach, local expertise, and
          commitment to quality sets us apart in the technology trading
          industry.
        </p>
        <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5"}>
          {siteConfig.capabilities.map((capability, index) => (
            <div
              key={index}
              className={
                "grid gap-4 items-center border hover:border-primary hover:[&>h1]:text-primary transition-all shadow" +
                " hover:shadow-primary hover:shadow-lg  " +
                " p-5 rounded"
              }
            >
              <span
                className={
                  "grid w-fit mx-auto place-content-center p-5 rounded-full bg-primary/90 text-white"
                }
              >
                <capability.icon />
              </span>
              <h1 className={"text-2xl font-bold"}>{capability.title}</h1>
              <p className={"font-semibold text-sm text-muted-foreground"}>
                {capability.description}
              </p>
              <div className={"flex flex-col gap-2 mt-5"}>
                {capability.features.map((feature, subIndex) => (
                  <span
                    key={subIndex}
                    className={"flex gap-2 items-start text-start"}
                  >
                    <CheckCircleIcon className={"text-primary"} />{" "}
                    <p
                      className={"text-sm font-semibold text-muted-foreground"}
                    >
                      {feature}
                    </p>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
